//#region import libraries

import React from 'react';
// custom components
import { Title as CustomTitle, NewScreen } from "_atoms";
import { UserProfile as UserProfileComponent } from "_organisms";

// bootstrap
import { Row, Col } from 'react-bootstrap';
//#endregion

const UserProfile = (props) => {

    return (
        <NewScreen>

            {/* Title & Subtitle */}
            <Row>
                <Col>
                    <CustomTitle subtitle={"User Profile"} description={"View information on a PRM Passenger"} />
                </Col>
            </Row>

            <UserProfileComponent />

        </NewScreen>
    );
};

export default UserProfile;
